import { Flex, Skeleton } from '@chakra-ui/react';
import { HeaderMarginContainer } from 'Deer/components/HeaderComponents/HeaderMarginContainer';

export const SurveyCreationLoader = () => (
  <HeaderMarginContainer wrapperProps={{ h: 'calc(100vh - 12px - 8px)' }}>
    <Flex flexDir="column" gap="10px" h="100%">
      <Skeleton h="24px" w="30%" borderRadius="8px" />
      <Skeleton h="64px" w="100%" borderRadius="8px" />
      <Skeleton flex="1" h="100%" w="100%" borderRadius="8px" />
    </Flex>
  </HeaderMarginContainer>
);

export const SurveySectionLoader = () => (
  <HeaderMarginContainer wrapperProps={{ h: 'calc(100vh - 12px - 8px)' }}>
    <Flex flexDir="column" gap="10px" h="100%" bg="white" p="12px" borderRadius="8px">
      <Skeleton h="60px" w="30%" borderRadius="8px" />
      <Skeleton h="44px" w="100%" borderRadius="8px" />
      <Skeleton h="44px" w="100%" borderRadius="8px" />
      <Skeleton h="44px" w="100%" borderRadius="8px" />
    </Flex>
  </HeaderMarginContainer>
);
